export const API_ID = 'https://enigmatic-dusk-17553.herokuapp.com/';
export const API_LOGIN = 'sessions';
export const API_REGISTRATION = 'registrations';
export const API_HOUSE = 'houses';
export const API_FAVOURITE = 'favorites';
